import clsx from 'clsx'

/* blocks */
import IndividualPageHero from './components/IndividualPageHero/IndividualPageHero'
import Episodes from './components/Episodes/Episodes'
import Resources from './components/Resources/Resources'
import GetStarted from './components/GetStarted/GetStarted'

/* utils */
import {
  ContentMarketingLeaders2025Attributes,
  IndividualGml2025SpeakersPageAttributes
} from '@/utils/queries/gml_2025'

/* styling */
import styles from './_.module.css'

interface Props {
  data: IndividualGml2025SpeakersPageAttributes
  speakerDetails: ContentMarketingLeaders2025Attributes[]
}

function GML2025IndividualPage({ data, speakerDetails }: Props): JSX.Element {
  const pastEpisodeList = speakerDetails.filter(
    details => details.episodeType === 'Past_Episode'
  )

  return (
    <>
      <IndividualPageHero
        quote={data.quote}
        name={data.name}
        companyName={data.companyName}
        designation={data.designation}
        profileImage={data.profileImage.data.attributes}
        linkedinLink={data.linkedinLink}
        instagramLink={data.instagramLink}
        twitterLink={data.twitterLink}
      />

      <section className="container max-w-col-10 mx-auto | my-5 md:my-18">
        <div
          className={clsx(
            styles.bio_section,
            'prose-strong:font-medium prose-headings:font-medium | col-span-full'
          )}
          dangerouslySetInnerHTML={{ __html: data.bio }}
        />
      </section>

      {pastEpisodeList.length > 0 ? (
        <Episodes
          title="Past Episodes"
          titleClass="text-2xl lg:text-3xl font-semibold text-gray-90"
          bgColor="bg-gradient-to-b from-[#FFEBB1] to-[#FFFFFF]"
          lists={pastEpisodeList}
        />
      ) : null}

      <Resources />

      <GetStarted
        className="bg-gradient-to-b from-[#1700EB] to-[#391966]"
        primaryHeadline={data.getStarted.title ?? ''}
        subText={data.getStarted.description ?? ''}
        image={data.getStarted.multimedia?.media?.data?.attributes}
        primaryCta={data.getStarted.link}
      />
    </>
  )
}

export default GML2025IndividualPage
